module.exports = __webpack_public_path__ + "img/gabby_home_logo.8fb49f5.png";